export function NotesSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/notes.svg'"></ng-include>`
    }
}